import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-phone-svg',
    templateUrl: './phone-svg.component.html',
    styleUrls: ['./phone-svg.component.scss'],
})
export class PhoneSvgComponent {}
